import React, { useEffect, useRef } from "react"
import { useLocation } from "wouter"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

const workshops = [
  {
    title: "The Founder's Inner Game",
    desc: "This session helps founders understand why change and innovation can often fail, and how leading themselves differently creates momentum.",
    tags: ["leadership", "mentoring"],
  },
  {
    title: "Founder Focus: Building From What Matters Most",
    desc: "This session helps founders get clear on who they are, what they stand for, and how to focus their limited energy on what truly matters in the early stages.",
    tags: ["leadership", "mentoring"],
  },
  {
    title: "Goals That Actually Move You Forward",
    desc: "A session focused on helping founders how to set goals that build motivation, learning, and progress, rather than stress, avoidance, or false performance.",
    tags: ["leadership", "mentoring", "product"],
  },
  {
    title: "Confidence Under Pressure: Staying Steady as a Founder",
    desc: "Through this session we help founders build confidence and discipline by working with their strengths, relationships, and daily habits, especially when things get hard.",
    tags: ["leadership"],
  },
  {
    title: "From Idea to Evidence",
    desc: "A practical workshop on turning assumptions into validated learning. Founders map their riskiest hypotheses, design real-world tests, and learn how to measure traction beyond vanity metrics. Focus: speed of learning, not speed of building.",
    tags: ["product", "mentoring"],
  },
  {
    title: "Detachment as a Founder Skill",
    desc: "A tougher session about ego, attachment, sunk cost bias, and when to pivot. Founders learn how to evaluate whether to persevere, pivot, or stop. Use data and behavioural signs to understand what matters.",
    tags: ["leadership", "mentoring", "product"],
  },
  {
    title: "Product Focus: Recognising What Matters",
    desc: "Founders learn how to decide what not to build. Covers outcome driven roadmapping, defining value, sequencing features, and avoiding overbuilding. Heavy emphasis on clarity of user problem and measurable impact.",
    tags: ["leadership", "mentoring", "product"],
  },
]

export function Workshops() {
  const [, navigate] = useLocation()
  const rowRefs = useRef([])

  useEffect(() => {
    document.body.style.backgroundColor = ""
    document.body.style.color = ""

    const ctx = gsap.context(() => {
      rowRefs.current.forEach((row) => {
        gsap.fromTo(
          row,
          { opacity: 0, y: 16 },
          {
            opacity: 1,
            y: 0,
            duration: 0.6,
            ease: "power3.out",
            scrollTrigger: { trigger: row, start: "top 92%" },
          }
        )
      })
      ScrollTrigger.refresh()
    })

    return () => ctx.revert()
  }, [])

  return (
    <div className="workshops-page">
      <div className="services-header">
        <p className="eyebrow">Workshops & activities</p>
        <h1 className="services-headline">Sessions built<br />for founders.</h1>
      </div>

      <div className="workshops-table">
        <div className="workshops-header-row">
          <span className="workshops-col-title">Title</span>
          <span className="workshops-col-desc">Description</span>
          <span className="workshops-col-focus">Focus</span>
        </div>

        {workshops.map((w, i) => (
          <div key={i} ref={el => (rowRefs.current[i] = el)} className="workshop-row">
            <span className="workshop-title">{w.title}</span>
            <span className="workshop-desc">{w.desc}</span>
            <div className="workshop-tags">
              {w.tags.map(tag => (
                <span key={tag} className="workshop-tag">{tag}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
